module.exports = __webpack_public_path__ + "images/lpage-streaks-2.png";